var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "community-form" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c("div", { staticClass: "form-layout" }, [
            _c(
              "div",
              { staticClass: "form-left" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "封面图" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", [
                              _c("div", [_vm._v("封面图")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "image-tip" }, [
                                _vm._v("(670px * 800px)"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: "#",
                          "list-type": "picture-card",
                          limit: 1,
                          "auto-upload": false,
                          "file-list": _vm.realImages,
                          "on-exceed": _vm.handleExceed,
                          "before-upload": _vm.beforeImageUpload,
                          "on-remove": _vm.handleRemoveReal,
                          "on-preview": _vm.handlePictureCardPreview,
                          "on-change": _vm.handleRealImageChange,
                        },
                      },
                      [_c("i", { staticClass: "el-icon-plus" })]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "背景图" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", [
                              _c("div", [_vm._v("背景图")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "image-tip" }, [
                                _vm._v("(479px * 1038px)"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: "#",
                          "list-type": "picture-card",
                          limit: 1,
                          "auto-upload": false,
                          "file-list": _vm.backgroundImages,
                          "on-exceed": _vm.handleExceed,
                          "before-upload": _vm.beforeImageUpload,
                          "on-remove": _vm.handleRemoveBackground,
                          "on-preview": _vm.handlePictureCardPreview,
                          "on-change": _vm.handleBackgroundImageChange,
                        },
                      },
                      [_c("i", { staticClass: "el-icon-plus" })]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-right" },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "细节图" } },
                  [
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          action: "#",
                          "list-type": "picture-card",
                          "auto-upload": false,
                          "file-list": _vm.merchantImages,
                          "before-upload": _vm.beforeImageUpload,
                          "on-remove": _vm.handleRemoveMerchant,
                          "on-preview": _vm.handlePictureCardPreview,
                          "on-change": _vm.handleMerchantImageChange,
                        },
                      },
                      [_c("i", { staticClass: "el-icon-plus" })]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-tip" }, [
                      _vm._v(
                        "注：(600px * 920px)上传细节图最多9张，建议为：细节图、场景图，图片尺寸限制1M内。"
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否显示" } },
                  [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#13ce66",
                        "active-value": 1,
                        "inactive-value": 0,
                      },
                      model: {
                        value: _vm.formData.showFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "showFlag", $$v)
                        },
                        expression: "formData.showFlag",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }